import { pickBy } from 'lodash/fp';

export const pickTruthyKeys = pickBy(undefined);
